import { useEvaluationResultQuery } from '../nuvemPagoCommonsApi';

const DEFAULT_CACHE_TTL = 120;

interface QuerySubscriptionOptions {
  skip?: boolean;
  refetchOnMountOrArgChange?: boolean | number;
  pollingInterval?: number;
  refetchOnReconnect?: boolean;
  refetchOnFocus?: boolean;
}

export function useEvaluationResult(
  featureFlag: string,
  options: QuerySubscriptionOptions = {},
) {
  return useEvaluationResultQuery(featureFlag, {
    refetchOnMountOrArgChange: DEFAULT_CACHE_TTL,
    ...options,
  });
}
